import { render } from "./RolesList.vue?vue&type=template&id=19ecf49a&scoped=true"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"

import "./RolesList.vue?vue&type=style&index=0&id=19ecf49a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ecf49a"]])

export default __exports__